var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import config from "../config.json";
import * as _ from "lodash";
import { updateSiteStore, } from "../stores/SiteStore";
import { parseSurvey, setFillContext } from "../stores/SurveyFillStore";
import { emptyState as emptySurveyFill, emptySurveyMatchStatus, } from "reliance-private-survey-parser/dist/surveyParseTypes";
import ReactPixel from "@bettercart/react-facebook-pixel";
import { Amplify, API } from "aws-amplify";
import awsconfig from "../aws-exports";
import Cookies from "js-cookie";
/// load site and break out identifiers
var queryString = window.location.search;
var urlParams = new URLSearchParams(queryString);
export function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(" ");
}
export var renderHTML = function (rawHTML, n) {
    return React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML }, className: n });
};
export var getPhone = function (state) {
    var _a, _b;
    var value = "";
    if ((_a = state.platformIdentifiersByKey["Config:DefaultPhoneNumber"]) === null || _a === void 0 ? void 0 : _a.value) {
        value = state.platformIdentifiersByKey["Config:DefaultPhoneNumber"].value;
    }
    else if ((_b = state.platformIdentifiersByKey["Config:DefaultUtmSource"]) === null || _b === void 0 ? void 0 : _b.value) {
        value = getUtmItem("phone", state.platformIdentifiersByKey["Config:DefaultUtmSource"].value);
    }
    else {
        value = getUtmItem("phone");
    }
    return value;
};
export var getUtmItem = function (item, pick) {
    var utm = pick ? pick : urlParams.get("utm_source");
    var value = "";
    if (utm && config.utm_map[utm]) {
        value = config.utm_map[utm][item];
    }
    if (!value && config.utm_map["default"]) {
        value = config.utm_map["default"][item];
    }
    return value;
};
export var formatPhone = function (p) {
    var v = p;
    var front = "";
    var area = "";
    var pre = "";
    var post = "";
    var maxlength = 10;
    /// front char?
    if (v[0] === "1") {
        front = "1 ";
        v = v.substring(1);
    }
    // cap at MAX
    v = v.substring(0, maxlength);
    post = v.substring(6);
    if (post) {
        v = v.substring(0, 6);
    }
    pre = v.substring(3);
    if (pre) {
        v = v.substring(0, 3);
    }
    area = v;
    /// DEBUG - see breakdown
    // console.log(`v=[${v}]`);
    // console.log(`front=[${front}]`);
    // console.log(`area=[${area}]`);
    // console.log(`pre=[${pre}]`);
    // console.log(`post=[${post}]`);
    if (post) {
        v = "".concat(front, "(").concat(area, ") ").concat(pre, "-").concat(post);
    }
    else if (pre) {
        v = "".concat(front, "(").concat(area, ") ").concat(pre);
    }
    else if (area) {
        v = "".concat(front, "(").concat(area);
    }
    else if (front !== "") {
        v = "".concat(front, "(");
    }
    else {
        v = "(";
    }
    return v;
};
function doTrackBackend(state, params) {
    Amplify.configure(awsconfig[state.env.env]);
    setTimeout(function () {
        var apiName = "backend";
        var path = "/live/event/track";
        var myInit = {
            response: true,
            body: {
                siteId: state.site.id,
                params: params,
                platformIdentifiers: state.platformIdentifiersByKey,
                cookies: Cookies.get(),
                location: window.location,
            },
        };
        API.post(apiName, path, myInit)
            .then(function (response) {
            // console.log("track resp");
            // console.log(response);
        })
            .catch(function (error) {
            console.log("track err");
            console.log(error);
        });
    }, 200);
}
export function doGeo(env) {
    return __awaiter(this, void 0, void 0, function () {
        var apiName, path, myInit, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Amplify.configure(awsconfig[env]);
                    apiName = "backend";
                    path = "/live/event/geo";
                    myInit = {
                        response: true,
                        body: {},
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, API.post(apiName, path, myInit)];
                case 2:
                    response = _a.sent();
                    updateSiteStore({
                        geoInfo: response.data.result,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.log("geo fail");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function doSurveyInit(site_state, state) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var apiName, path, myInit, surveyFill, response, globalContextConfiguration, sourceContextConfiguration, firmContextConfigurations, responseTypedSurvey, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Amplify.configure(state.env ? state.env : "stage");
                    apiName = "backend";
                    path = "/live/event/survey_init";
                    myInit = {
                        response: true,
                        body: {
                            sourceId: site_state.site.surveySystemSourceId,
                        },
                    };
                    surveyFill = {};
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, API.post(apiName, path, myInit)];
                case 2:
                    response = _b.sent();
                    if (response.data.result.getInProgressSurvey) {
                        // console.log("INPROG!");
                        surveyFill = __assign(__assign({}, emptySurveyFill), { survey: response.data.result.getInProgressSurvey, viewingMode: "PREVIEW" });
                    }
                    else {
                        globalContextConfiguration = {};
                        sourceContextConfiguration = {};
                        firmContextConfigurations = {};
                        responseTypedSurvey = response.data.result.addSurveyUnmatched;
                        globalContextConfiguration = response.data.result.globalContextConfiguration;
                        /// set source (GLOBAL)
                        sourceContextConfiguration = response.data.result.sourceContextConfigurations.filter(function (cr) {
                            return cr.firmId === "GLOBAL";
                        })[0].contextConfiguration;
                        /// set source (FIRMS))
                        response.data.result.sourceContextConfigurations
                            .filter(function (cr) {
                            return cr.firmId !== "GLOBAL";
                        })
                            .forEach(function (cr, idx) {
                            firmContextConfigurations[cr.firmId] = response.data.result.sourceContextConfigurations[idx].contextConfiguration;
                        });
                        /// have to do it like this to avoid having some information stick around after a reset
                        surveyFill = _.cloneDeep(emptySurveyFill);
                        surveyFill["survey"] = _.cloneDeep(responseTypedSurvey);
                        surveyFill["surveyMatchStatus"] = _.cloneDeep(emptySurveyMatchStatus);
                        surveyFill["viewingMode"] = "PREVIEW";
                        surveyFill["globalContextConfiguration"] = globalContextConfiguration;
                        surveyFill["sourceContextConfiguration"] = sourceContextConfiguration;
                        surveyFill["firmContextConfigurations"] = firmContextConfigurations;
                        surveyFill["desiredFirmOrder"] = ((_a = response.data.result.desiredFirmOrder) !== null && _a !== void 0 ? _a : []);
                        //console.log(`in survey init!`);
                        // console.log(surveyFill);
                    }
                    setFillContext(surveyFill);
                    parseSurvey();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    console.log("init fail");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function doSendVerifyCode(state) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var apiName, path, myInit, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    Amplify.configure(state.env ? state.env : "stage");
                    apiName = "backend";
                    path = "/live/event/survey_verify";
                    myInit = {
                        response: true,
                        body: {
                            phoneNumber: (_a = state.phoneVerifyStatus.phoneNumber) !== null && _a !== void 0 ? _a : state.answerStorage["caller_identity"]["phone"],
                        },
                    };
                    return [4 /*yield*/, API.post(apiName, path, myInit)];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data.result.code];
            }
        });
    });
}
export function doSurveyMatch(state) {
    return __awaiter(this, void 0, void 0, function () {
        var apiName, path, myInit, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Amplify.configure(state.env ? state.env : "stage");
                    apiName = "backend";
                    path = "/live/event/survey_convert";
                    myInit = {
                        response: true,
                        body: {
                            sourceId: state.sourceContextConfiguration.sourceId,
                            globalContextConfigurationID: state.globalContextConfiguration.id,
                            sourceContextConfigurationID: state.sourceContextConfiguration.id,
                            firmContextConfigurationID: state.firmContextConfigurations[state.surveyMatchStatus.matchedFirmId].id,
                            answers: state.matchQuestions.map(function (q, qIdx) {
                                var s = __assign({}, state.answerStorage[q.questionToken]);
                                delete s.__typename;
                                return s;
                            }),
                        },
                    };
                    return [4 /*yield*/, API.post(apiName, path, myInit)];
                case 1:
                    response = _a.sent();
                    setFillContext(__assign(__assign({}, emptySurveyFill), { viewingMode: "PREVIEW", survey: response.data.result.addSurveyMatched }));
                    return [2 /*return*/];
            }
        });
    });
}
export function doAbandonMatchedSurvey(state) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var apiName, path, myInit;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    Amplify.configure(state.env ? state.env : "stage");
                    apiName = "backend";
                    path = "/live/event/survey_abandon";
                    myInit = {
                        response: true,
                        body: {
                            sourceId: (_a = state.survey) === null || _a === void 0 ? void 0 : _a.sourceId,
                            surveyId: (_b = state.survey) === null || _b === void 0 ? void 0 : _b.id,
                        },
                    };
                    return [4 /*yield*/, API.post(apiName, path, myInit)];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function doStashAnswers(state) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var apiName, path, myInit;
        return __generator(this, function (_d) {
            Amplify.configure(state.env ? state.env : "stage");
            apiName = "backend";
            path = "/live/event/survey_stash";
            myInit = {
                response: true,
                body: {
                    surveyId: (_a = state.survey) === null || _a === void 0 ? void 0 : _a.id,
                    answers: (_c = (_b = state.survey) === null || _b === void 0 ? void 0 : _b.questions) === null || _c === void 0 ? void 0 : _c.filter(function (q, qIdx) {
                        return state.questionStatusStorage[q.questionToken].answered;
                    }).map(function (q, qIdx) {
                        var s = __assign({}, state.answerStorage[q.questionToken]);
                        delete s.__typename;
                        return s;
                    }),
                },
            };
            API.post(apiName, path, myInit);
            return [2 /*return*/];
        });
    });
}
export function doTrack(state, params) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return __awaiter(this, void 0, void 0, function () {
        var utm, eventId, eventTime, event_data, queryParams, leadId0, em, fn, ln, ph, fb_event, fb_data, _j, leadIds, _i, _k, n, _l, _m, emSha, fnSha, lnSha, phSha, sha_data, ge, geSha, st, stSha;
        var _o;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0:
                    utm = ((_a = urlParams.get("utm_source")) !== null && _a !== void 0 ? _a : "").toLowerCase();
                    eventId = (Math.floor(Math.random() * 9999999999) + 1).toString().padStart(10, "0");
                    eventTime = String(Math.floor(new Date().getTime() / 1000));
                    event_data = { eventID: eventId, eventTime: eventTime };
                    params.eventId = eventId;
                    params.eventTime = eventTime;
                    queryParams = new URLSearchParams(window.location.search);
                    leadId0 = window.atob((_b = queryParams.get("lead_id_0")) !== null && _b !== void 0 ? _b : "").toLowerCase();
                    em = window.atob((_c = queryParams.get("em")) !== null && _c !== void 0 ? _c : "").toLowerCase();
                    fn = window.atob((_d = queryParams.get("fn")) !== null && _d !== void 0 ? _d : "").toLowerCase();
                    ln = window.atob((_e = queryParams.get("ln")) !== null && _e !== void 0 ? _e : "").toLowerCase();
                    ph = window.atob((_f = queryParams.get("ph")) !== null && _f !== void 0 ? _f : "").toLowerCase();
                    if (!((["facebook", ""].includes(utm) || state.site.allPlatforms) &&
                        state.platformIdentifiersByKey["Facebook:FB_PIXEL_ID"])) return [3 /*break*/, 12];
                    fb_event = "ViewContent";
                    fb_data = Object.assign(params.data ? params.data : {}, {
                        content_name: params.label.toLowerCase(),
                        content_category: params.category.toLowerCase(),
                    });
                    /// this changes things like dx=Lung Cancer into dx=yes for facebook events
                    if (!["yes", "no", "exit"].includes(fb_data["content_name"])) {
                        fb_data["content_name"] = "yes";
                    }
                    /// values to hash
                    _j = params;
                    _o = {};
                    return [4 /*yield*/, doSha("us")];
                case 1:
                    /// values to hash
                    _j.hashedData = (_o.country = _p.sent(),
                        _o);
                    leadIds = [];
                    for (_i = 0, _k = [0, 1, 2, 3, 4]; _i < _k.length; _i++) {
                        n = _k[_i];
                        if (queryParams.get("lead_id_".concat(n))) {
                            leadIds.push(window.atob(queryParams.get("lead_id_".concat(n))));
                        }
                    }
                    if (!(leadIds.length > 0)) return [3 /*break*/, 3];
                    _l = params.hashedData;
                    _m = "external_id";
                    return [4 /*yield*/, doSha(leadIds.join(","))];
                case 2:
                    _l[_m] = _p.sent();
                    _p.label = 3;
                case 3: return [4 /*yield*/, doSha(em)];
                case 4:
                    emSha = _p.sent();
                    return [4 /*yield*/, doSha(fn)];
                case 5:
                    fnSha = _p.sent();
                    return [4 /*yield*/, doSha(ln)];
                case 6:
                    lnSha = _p.sent();
                    return [4 /*yield*/, doSha(ph)];
                case 7:
                    phSha = _p.sent();
                    sha_data = {
                        em: emSha,
                        ph: phSha,
                        fn: fnSha,
                        ln: lnSha,
                    };
                    if (!queryParams.get("ge")) return [3 /*break*/, 9];
                    ge = window.atob((_g = queryParams.get("ge")) !== null && _g !== void 0 ? _g : "").toLowerCase();
                    return [4 /*yield*/, doSha(ge)];
                case 8:
                    geSha = _p.sent();
                    sha_data["ge"] = geSha;
                    _p.label = 9;
                case 9:
                    if (!state.geoInfo["region"]) return [3 /*break*/, 11];
                    st = state.geoInfo["region"].toLowerCase();
                    return [4 /*yield*/, doSha(st)];
                case 10:
                    stSha = _p.sent();
                    sha_data["st"] = stSha;
                    _p.label = 11;
                case 11:
                    params.hashedData = Object.assign({}, params.hashedData, sha_data);
                    switch (params.action) {
                        case "view":
                            fb_event = "PageView";
                            // create smaller set of info for passing
                            fb_data = {};
                            break;
                        case "lead":
                            fb_event = "Lead";
                            break;
                        case "conversion":
                            fb_event = "CompleteRegistration";
                            break;
                    }
                    params.data = Object.assign((_h = params.data) !== null && _h !== void 0 ? _h : {}, fb_data); // no event data needed as they are passed in the params
                    /// SEND IT IF NOT DISABLED BY BACKEND TRACK
                    if (!state.site.backendTrackOnly) {
                        ReactPixel.track(fb_event, fb_data, event_data);
                    }
                    _p.label = 12;
                case 12:
                    // conversion only
                    if (params.action === "conversion") {
                        // google - conversion only
                        if ((["google"].includes(utm) || state.site.allPlatforms) &&
                            state.platformIdentifiersByKey["Google:Ads ID"] &&
                            state.platformIdentifiersByKey["Google:Event Conversion"]) {
                            try {
                                window.gtag("event", "conversion", {
                                    send_to: state.platformIdentifiersByKey["Google:Event Conversion"].value,
                                });
                            }
                            catch (err) {
                                console.log("g conv fail");
                            }
                        }
                        // taboola - conversion only
                        if ((["taboola"].includes(utm) || state.site.allPlatforms) && state.platformIdentifiersByKey["Taboola:ID"]) {
                            try {
                                window._tfa.push({
                                    notify: "event",
                                    name: "lead",
                                    id: state.platformIdentifiersByKey["Taboola:ID"].value,
                                });
                            }
                            catch (err) {
                                console.log("tb conv fail");
                            }
                        }
                        // twitter - conversion only
                        if ((["twitter"].includes(utm) || state.site.allPlatforms) && state.platformIdentifiersByKey["Twitter:ID"]) {
                            try {
                                window.twq("event", state.platformIdentifiersByKey["Twitter:ID"].value, {
                                    conversion_id: leadId0,
                                    email_address: em,
                                    phone_number: "+" + ph, // phone number in E164 standard - comes over as (18185551212), e164 = +14155552671
                                });
                            }
                            catch (err) {
                                console.log("tw conv fail");
                            }
                        }
                    }
                    doTrackBackend(state, params);
                    return [2 /*return*/];
            }
        });
    });
}
export function doInit(state) {
    // console.log("doInit()");
    var _a, _b;
    var utm = ((_a = urlParams.get("utm_source")) !== null && _a !== void 0 ? _a : "").toLowerCase();
    var page = window.location.pathname.endsWith("thankyou") ? "thankyou" : "front";
    var advancedMatching = {
        country: "us",
    };
    var queryParams = new URLSearchParams(window.location.search);
    //check for state geo match
    if (state.geoInfo["region"]) {
        advancedMatching["st"] = state.geoInfo["region"].toLowerCase();
    }
    //check for incoming adv match
    for (var _i = 0, _c = ["em", "fn", "ln", "ph", "ge"]; _i < _c.length; _i++) {
        var i = _c[_i];
        if (queryParams.get(i)) {
            advancedMatching[i] = window.atob(queryParams.get(i));
        }
    }
    //check for lead IDs
    var leadIds = [];
    for (var _d = 0, _e = [0, 1, 2, 3, 4]; _d < _e.length; _d++) {
        var n = _e[_d];
        if (queryParams.get("lead_id_".concat(n))) {
            leadIds.push(window.atob(queryParams.get("lead_id_".concat(n))));
        }
    }
    if (leadIds.length > 0) {
        advancedMatching["external_id"] = leadIds.join(",");
    }
    try {
        /// only init facebook conditionally
        if ((["facebook", ""].includes(utm) || state.site.allPlatforms) &&
            !state.site.backendTrackOnly &&
            state.platformIdentifiersByKey["Facebook:FB_PIXEL_ID"]) {
            ReactPixel.init(state.platformIdentifiersByKey["Facebook:FB_PIXEL_ID"].value, advancedMatching);
        }
    }
    catch (err) {
        console.log("fb init fail");
    }
    try {
        /// google init
        if ((["google"].includes(utm) || state.site.allPlatforms) &&
            state.platformIdentifiersByKey["Google:Analytics ID"]) {
            window.gtag("config", state.platformIdentifiersByKey["Google:Analytics ID"].value);
        }
        if ((["google"].includes(utm) || state.site.allPlatforms) && state.platformIdentifiersByKey["Google:Ads ID"]) {
            window.gtag("config", state.platformIdentifiersByKey["Google:Ads ID"].value);
            if (state.platformIdentifiersByKey["Google:Call Tracking"]) {
                window.gtag("config", state.platformIdentifiersByKey["Google:Call Tracking"].value, {
                    phone_conversion_number: getUtmItem("phone", "google"),
                });
            }
        }
    }
    catch (err) {
        console.log("g init fail");
    }
    try {
        /// taboola init
        if ((["taboola"].includes(utm) || state.site.allPlatforms) && state.platformIdentifiersByKey["Taboola:ID"]) {
            window._tfa.push({
                notify: "event",
                name: "page_view",
                id: state.platformIdentifiersByKey["Taboola:ID"].value,
            });
            window._tfa.push({
                notify: "event",
                name: "view_content",
                id: state.platformIdentifiersByKey["Taboola:ID"].value,
            });
        }
    }
    catch (err) {
        console.log("t init fail");
    }
    try {
        /// twitter init
        if ((["twitter"].includes(utm) || state.site.allPlatforms) && state.platformIdentifiersByKey["Twitter:ID"]) {
            var twitterIdSplit = String((_b = state.platformIdentifiersByKey["Twitter:ID"].value) !== null && _b !== void 0 ? _b : "").split("-");
            window.twq("config", twitterIdSplit[1]);
        }
    }
    catch (err) {
        console.log("twt init fail");
    }
    doTrack(state, { action: "view", label: page, what: "page", category: "page" });
    return state;
}
export function doConvert(state, params) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            // console.log(`convert init with ${state.env.env}`);
            Amplify.configure(awsconfig[state.env.env]);
            setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                var queryParams, apiName, path, myInit, gePath, myInitGe, success, response, err_1, geResponse, geErr_1, r, ph, showConversion, _i, _a, s;
                var _b, _c, _d, _e, _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0:
                            queryParams = new URLSearchParams();
                            apiName = "backend";
                            path = "/live/event/conversion";
                            myInit = {
                                response: true,
                                body: {
                                    platformIdentifiers: state.platformIdentifiersByKey,
                                    cookies: Cookies.get(),
                                    location: window.location,
                                    navigator: (_b = window.navigator) !== null && _b !== void 0 ? _b : {},
                                    formAnswers: state.formAnswers,
                                    questionAnswers: state.questionAnswers,
                                    sourceIds: state.helpMode ? [state.helpTort] : state.qualifiesFor,
                                    disqualifySourceIds: state.helpMode ? [] : state.disqualifiesFor,
                                    extra: {
                                        referrer: (_c = document === null || document === void 0 ? void 0 : document.referrer) !== null && _c !== void 0 ? _c : "",
                                        loadTimestamp: state.loadTimestamp,
                                        quizTimestamp: state.quizTimestamp,
                                    },
                                },
                            };
                            gePath = "/live/event/ge";
                            myInitGe = {
                                response: true,
                                body: {
                                    name: window.btoa(state.formAnswers["first_name"].toLowerCase()),
                                },
                            };
                            success = false;
                            _h.label = 1;
                        case 1:
                            _h.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, API.post(apiName, path, myInit)];
                        case 2:
                            response = _h.sent();
                            success = true;
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _h.sent();
                            return [3 /*break*/, 4];
                        case 4:
                            _h.trys.push([4, 6, , 7]);
                            return [4 /*yield*/, API.post(apiName, gePath, myInitGe)];
                        case 5:
                            geResponse = _h.sent();
                            // console.log(geResponse);
                            if ((_d = geResponse.data) === null || _d === void 0 ? void 0 : _d.ge) {
                                queryParams.append("ge", window.btoa(geResponse.data.ge.toLowerCase()));
                            }
                            return [3 /*break*/, 7];
                        case 6:
                            geErr_1 = _h.sent();
                            return [3 /*break*/, 7];
                        case 7:
                            if (urlParams.get("t")) {
                                queryParams.append("t", urlParams.get("t"));
                            }
                            for (r in (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.result) !== null && _f !== void 0 ? _f : []) {
                                queryParams.append("extern_source_id_".concat(r), window.btoa("".concat(response.data.result[r]["extern_source_id"])));
                                queryParams.append("lead_id_".concat(r), window.btoa("".concat(response.data.result[r]["lead_id"])));
                            }
                            ph = state.formAnswers["phone"].replace(/\D/g, "");
                            if (ph[0] !== "1") {
                                ph = "1" + ph;
                            }
                            queryParams.append("em", window.btoa(state.formAnswers["email"].toLowerCase()));
                            queryParams.append("fn", window.btoa(state.formAnswers["first_name"].toLowerCase()));
                            queryParams.append("ln", window.btoa(state.formAnswers["last_name"].toLowerCase()));
                            queryParams.append("ph", window.btoa(ph));
                            queryParams.append("utm_source", (_g = urlParams.get("utm_source")) !== null && _g !== void 0 ? _g : "");
                            showConversion = false;
                            for (_i = 0, _a = state.qualifiesFor; _i < _a.length; _i++) {
                                s = _a[_i];
                                if (!state.disqualifiesFor.includes(s)) {
                                    showConversion = true;
                                }
                            }
                            /// set to true conversion for help mode
                            if (state.helpMode) {
                                showConversion = true;
                            }
                            queryParams.append("sc", showConversion ? "1" : "0");
                            if (success) {
                                window.location.href =
                                    window.location.origin + window.location.pathname + "thankyou?success=1&" + queryParams.toString();
                            }
                            else {
                                window.location.href =
                                    window.location.origin + window.location.pathname + "thankyou?error=1&utm_source=nosource";
                            }
                            return [2 /*return*/];
                    }
                });
            }); }, 200);
            return [2 /*return*/];
        });
    });
}
export function doConvertSurvey(state, params) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            // console.log(`convert init with ${state.env.env}`);
            Amplify.configure(awsconfig[state.env.env]);
            setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                var queryParams, apiName, path, myInit, gePath, myInitGe, success, response, err_2, geResponse, geErr_2, redirect_url, r, ph, p;
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                return __generator(this, function (_k) {
                    switch (_k.label) {
                        case 0:
                            queryParams = new URLSearchParams();
                            apiName = "backend";
                            path = "/live/event/conversion";
                            myInit = {
                                response: true,
                                body: {
                                    platformIdentifiers: state.platformIdentifiersByKey,
                                    cookies: Cookies.get(),
                                    location: window.location,
                                    navigator: (_a = window.navigator) !== null && _a !== void 0 ? _a : {},
                                    // formAnswers: state.formAnswers,
                                    // questionAnswers: state.questionAnswers,
                                    sourceIds: [(_b = params.surveyFill.survey) === null || _b === void 0 ? void 0 : _b.sourceId],
                                    surveyAnswers: params.surveyFill.answerStorage,
                                    surveyId: (_c = params.surveyFill.survey) === null || _c === void 0 ? void 0 : _c.id,
                                    firmId: (_d = params.surveyFill.survey) === null || _d === void 0 ? void 0 : _d.firmId,
                                    extra: {
                                        referrer: (_e = document === null || document === void 0 ? void 0 : document.referrer) !== null && _e !== void 0 ? _e : "",
                                        loadTimestamp: state.loadTimestamp,
                                        quizTimestamp: state.quizTimestamp,
                                    },
                                },
                            };
                            gePath = "/live/event/ge";
                            myInitGe = {
                                response: true,
                                body: {
                                    name: window.btoa(params.surveyFill.answerStorage["caller_identity"]["first"].toLowerCase()),
                                },
                            };
                            success = false;
                            _k.label = 1;
                        case 1:
                            _k.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, API.post(apiName, path, myInit)];
                        case 2:
                            response = _k.sent();
                            success = true;
                            return [3 /*break*/, 4];
                        case 3:
                            err_2 = _k.sent();
                            return [3 /*break*/, 4];
                        case 4:
                            _k.trys.push([4, 6, , 7]);
                            return [4 /*yield*/, API.post(apiName, gePath, myInitGe)];
                        case 5:
                            geResponse = _k.sent();
                            // console.log(geResponse);
                            if ((_f = geResponse.data) === null || _f === void 0 ? void 0 : _f.ge) {
                                queryParams.append("ge", window.btoa(geResponse.data.ge.toLowerCase()));
                            }
                            return [3 /*break*/, 7];
                        case 6:
                            geErr_2 = _k.sent();
                            return [3 /*break*/, 7];
                        case 7:
                            if (urlParams.get("t")) {
                                queryParams.append("t", urlParams.get("t"));
                            }
                            redirect_url = "";
                            for (r in (_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.result) !== null && _h !== void 0 ? _h : []) {
                                queryParams.append("extern_source_id_".concat(r), window.btoa("".concat(response.data.result[r]["extern_source_id"])));
                                queryParams.append("lead_id_".concat(r), window.btoa("".concat(response.data.result[r]["lead_id"])));
                                redirect_url = response.data.result[r]["redirect_url"];
                            }
                            ph = params.surveyFill.answerStorage["caller_identity"]["phone"].replace(/\D/g, "");
                            if (ph[0] !== "1") {
                                ph = "1" + ph;
                            }
                            queryParams.append("em", window.btoa(params.surveyFill.answerStorage["caller_identity"]["email"].toLowerCase()));
                            queryParams.append("fn", window.btoa(params.surveyFill.answerStorage["caller_identity"]["first"].toLowerCase()));
                            queryParams.append("ln", window.btoa(params.surveyFill.answerStorage["caller_identity"]["last"].toLowerCase()));
                            queryParams.append("ph", window.btoa(ph));
                            queryParams.append("utm_source", (_j = urlParams.get("utm_source")) !== null && _j !== void 0 ? _j : "");
                            if (success && redirect_url) {
                                setFillContext({
                                    surveyMatchStatus: __assign(__assign({}, params.surveyFill.surveyMatchStatus), { docusignUrl: redirect_url }),
                                });
                            }
                            else {
                                p = window.location.pathname;
                                if (p)
                                    window.location.href =
                                        window.location.origin + p.replace(/\/+$/g, "") + "/thankyou?error=1&utm_source=nosource";
                            }
                            return [2 /*return*/];
                    }
                });
            }); }, 200);
            return [2 /*return*/];
        });
    });
}
function buf2hex(buffer) {
    // buffer is an ArrayBuffer
    return Array.prototype.map.call(new Uint8Array(buffer), function (x) { return ("00" + x.toString(16)).slice(-2); }).join("");
}
export function doSha(s) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!s) return [3 /*break*/, 2];
                    return [4 /*yield*/, window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(s))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, buf2hex(result)];
                case 2: return [2 /*return*/, ""];
            }
        });
    });
}
